import * as errors from '@attain-apps/errors'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
import * as gql from '../gql'

export const executeGet = store.effects.create((feature: Feature) =>
  feature.actions.get.request.observe().pipe(
    // NOTE: concatMap ensures that every request is completed, but the latest
    // get is always the last one executed (and thus written to the state)
    rxjs.concatMap(action =>
      // TODO: after the first response, everything else should be a follow
      // up success or follow up error
      gql.queries.me.executor().pipe(
        rxjs.map(result => {
          if (result === undefined) {
            // NOTE: while we could use NotFoundError, it is really unexpected to
            // receive nothing for the current user, so this is a more appropriate
            // message to display to the user
            throw new errors.UnexpectedError()
          }
          return result
        }),
        // Handles success
        rxjs.map(response =>
          feature.actions.get.success.from(action).create({
            request: action.data,
            response,
          }),
        ),
        // Handles error
        rxjs.catchError(error =>
          rxjs.of(
            feature.actions.get.error.from(action).create({
              error,
              request: action.data,
            }),
          ),
        ),
      ),
    ),
  ),
)
